import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = {
  class: "home",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = { class: "tbdc-floatingtoolbarcontainer" }
const _hoisted_3 = { class: "tbdc-floatingtoolbar tbdc-elevation-5 d-print-none" }
const _hoisted_4 = {
  key: 2,
  class: "tbdc-floatingtoolbar tbdc-elevation-5 d-print-none",
  style: {"position":"fixed","top":"96px","left":"50%","transform":"translateX(-50%)","min-width":"320px","max-width":"600px","height":"auto","font-size":"13px","background-color":"darkorange !important","opacity":"0.95","color":"white","padding-left":"16px","padding-right":"16px","padding-top":"8px","padding-bottom":"8px","z-index":"1001"}
}
const _hoisted_5 = { style: {"margin-top":"4px"} }
const _hoisted_6 = { class: "tbdc-drawercontainer tbdc-drawercontainerleft" }
const _hoisted_7 = {
  style: {"height":"100%"},
  class: "tbdc-elevation-5"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "text-grey"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "tbdc-drawercontainer tbdc-drawercontainerright" }
const _hoisted_13 = {
  style: {"height":"100%"},
  class: "tbdc-elevation-5"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  class: "text-grey"
}
const _hoisted_19 = {
  key: 2,
  class: "text-grey"
}
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = {
  key: 1,
  class: "ma-0"
}
const _hoisted_22 = { class: "mb-2 tbdc-clickable" }
const _hoisted_23 = { class: "mb-2 tbdc-clickable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocationReport = _resolveComponent("LocationReport")!
  const _component_ScenarioReport = _resolveComponent("ScenarioReport")!
  const _component_LocationScores = _resolveComponent("LocationScores")!
  const _component_AppDialog = _resolveComponent("AppDialog")!
  const _component_AreaScores = _resolveComponent("AreaScores")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_MatchingLocationsOutputChart = _resolveComponent("MatchingLocationsOutputChart")!
  const _component_MatchingLocationsRadarChart = _resolveComponent("MatchingLocationsRadarChart")!
  const _component_DriversChart = _resolveComponent("DriversChart")!
  const _component_PropertiesChart = _resolveComponent("PropertiesChart")!
  const _component_Mapbox = _resolveComponent("Mapbox")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_FloatingMenu = _resolveComponent("FloatingMenu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_LocationInformation = _resolveComponent("LocationInformation")!
  const _component_ModelOutput = _resolveComponent("ModelOutput")!
  const _component_MatchingLocations = _resolveComponent("MatchingLocations")!
  const _component_CatchmentAreaInformation = _resolveComponent("CatchmentAreaInformation")!
  const _component_AreaInformation = _resolveComponent("AreaInformation")!
  const _component_CopyChanges = _resolveComponent("CopyChanges")!
  const _component_CloneScenario = _resolveComponent("CloneScenario")!
  const _component_BulkUploadLocationsDialog = _resolveComponent("BulkUploadLocationsDialog")!
  const _component_ExportAreasDialog = _resolveComponent("ExportAreasDialog")!
  const _component_EditScenario = _resolveComponent("EditScenario")!
  const _component_EditScenarioName = _resolveComponent("EditScenarioName")!
  const _component_EditLocation = _resolveComponent("EditLocation")!
  const _component_CloseLocation = _resolveComponent("CloseLocation")!
  const _component_EditModelParameters = _resolveComponent("EditModelParameters")!
  const _component_EditDrivers = _resolveComponent("EditDrivers")!
  const _component_EditNormalizedScoresFunctions = _resolveComponent("EditNormalizedScoresFunctions")!
  const _component_ScenarioProcessingLog = _resolveComponent("ScenarioProcessingLog")!
  const _component_NCalcTester = _resolveComponent("NCalcTester")!
  const _component_WhoHasAccess = _resolveComponent("WhoHasAccess")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_ctx.getModel)
    ? (_openBlock(), _createBlock(_component_v_main, {
        key: 0,
        class: "tbdc-fullwidthpage"
      }, {
        default: _withCtx(() => [
          (_ctx.locationReportVisible)
            ? (_openBlock(), _createBlock(_component_LocationReport, {
                key: 0,
                onStartBusy: _ctx.setStartBusy,
                onEndBusy: _ctx.setEndBusy,
                model: _ctx.getModel,
                subModel: _ctx.getSubModel,
                location: _ctx.getLocation,
                locations: _ctx.getLocations,
                locationProperties: _ctx.getLocationProperties,
                scenario: _ctx.getScenario,
                environment: _ctx.getEnvironment,
                locationCatchmentArea: _ctx.getLocationCatchmentArea,
                catchmentArea: _ctx.getCatchmentArea,
                matchingLocations: _ctx.getMatchingLocations,
                matchingScores: _ctx.getMatchingScores,
                matchingColors: _ctx.getMatchingColors,
                locationDrivers: _ctx.getLocationDrivers,
                class: "d-print-block tbdc-fullwidthpage",
                show: _ctx.locationReportVisible,
                onShowChanged: _cache[0] || (_cache[0] = ($event: any) => {_ctx.setLocationDrivers(null); _ctx.locationReportVisible = false;})
              }, null, 8, ["onStartBusy", "onEndBusy", "model", "subModel", "location", "locations", "locationProperties", "scenario", "environment", "locationCatchmentArea", "catchmentArea", "matchingLocations", "matchingScores", "matchingColors", "locationDrivers", "show"]))
            : _createCommentVNode("", true),
          (_ctx.scenarioReportVisible)
            ? (_openBlock(), _createBlock(_component_ScenarioReport, {
                key: 1,
                scenarioDifferences: _ctx.getScenarioDifferences,
                environment: _ctx.getEnvironment,
                model: _ctx.getModel,
                scenario: _ctx.getScenario,
                locations: _ctx.getLocations,
                class: "d-print-block tbdc-fullwidthpage",
                show: _ctx.scenarioReportVisible,
                onShowChanged: _cache[1] || (_cache[1] = ($event: any) => {_ctx.clearScenarioDifferences(); _ctx.scenarioReportVisible = false; })
              }, null, 8, ["scenarioDifferences", "environment", "model", "scenario", "locations", "show"]))
            : _createCommentVNode("", true),
          _createVNode(_component_AppDialog, {
            show: _ctx.getLocationScores != null && _ctx.locationScoresVisible,
            onShowChanged: _cache[2] || (_cache[2] = ($event: any) => {_ctx.locationScoresVisible = false;})
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tc("message.locationType" + _ctx.getModel.locationsType + "Scores")), 1)
            ]),
            content: _withCtx(() => [
              _createVNode(_component_LocationScores, {
                model: _ctx.getModel,
                locationScores: _ctx.getLocationScores
              }, null, 8, ["model", "locationScores"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_AppDialog, {
            show: _ctx.areaScoresVisible,
            onShowChanged: _cache[3] || (_cache[3] = ($event: any) => {_ctx.areaScoresVisible = false;})
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("message.areaScores")), 1)
            ]),
            content: _withCtx(() => [
              _createVNode(_component_AreaScores, {
                area: _ctx.getArea,
                model: _ctx.getModel
              }, null, 8, ["area", "model"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_AppDialog, {
            show: _ctx.matchingLocationsOutputChartVisible,
            onShowChanged: _cache[4] || (_cache[4] = ($event: any) => {_ctx.matchingLocationsOutputChartVisible = false;})
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("message.matchingLocationsOutputChart")) + " ", 1),
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                "max-width": "400",
                "open-delay": "250",
                "open-on-hover": true
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_icon, _mergeProps(props, { class: "ml-1" }), {
                    default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  }, 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.matchingLocationsOutputChartInfo")), 1)
                ]),
                _: 1
              })
            ]),
            content: _withCtx(() => [
              _createVNode(_component_MatchingLocationsOutputChart, {
                matchingLocations: _ctx.getMatchingLocations,
                location: _ctx.getLocation,
                model: _ctx.getModel,
                matchingColors: _ctx.getMatchingColors
              }, null, 8, ["matchingLocations", "location", "model", "matchingColors"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_AppDialog, {
            show: _ctx.matchingLocationsRadarChartVisible,
            onShowChanged: _cache[5] || (_cache[5] = ($event: any) => {_ctx.matchingLocationsRadarChartVisible = false;})
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("message.matchingLocationsSimilarityChart")) + " ", 1),
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                "max-width": "400",
                "open-delay": "250",
                "open-on-hover": true
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_icon, _mergeProps(props, { class: "ml-1" }), {
                    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  }, 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.matchingLocationsSimilarityChartInfo")), 1)
                ]),
                _: 1
              })
            ]),
            content: _withCtx(() => [
              _createVNode(_component_MatchingLocationsRadarChart, {
                matchingScores: _ctx.getMatchingScores,
                matchingColors: _ctx.getMatchingColors,
                location: _ctx.getLocation
              }, null, 8, ["matchingScores", "matchingColors", "location"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_AppDialog, {
            show: _ctx.getLocationDrivers != null && _ctx.driversChartVisible,
            onShowChanged: _cache[6] || (_cache[6] = ($event: any) => {_ctx.driversChartVisible = false; _ctx.setLocationDrivers(null);})
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("message.driversChart")) + " ", 1),
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                "max-width": "400",
                "open-delay": "250",
                "open-on-hover": true
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_icon, _mergeProps(props, { class: "ml-1" }), {
                    default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  }, 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.driversChartInfo")), 1)
                ]),
                _: 1
              })
            ]),
            content: _withCtx(() => [
              _createVNode(_component_DriversChart, {
                location: _ctx.getLocation,
                locationDrivers: _ctx.getLocationDrivers
              }, null, 8, ["location", "locationDrivers"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_AppDialog, {
            show: _ctx.propertiesChartVisible,
            onShowChanged: _cache[7] || (_cache[7] = ($event: any) => {_ctx.propertiesChartVisible = false; _ctx.getPropertiesChart.data = null})
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("message.propertiesChart")) + " ", 1),
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                "max-width": "400",
                "open-delay": "250",
                "open-on-hover": true
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_icon, _mergeProps(props, { class: "ml-1" }), {
                    default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  }, 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.propertiesChartInfo")), 1)
                ]),
                _: 1
              })
            ]),
            content: _withCtx(() => [
              _createVNode(_component_PropertiesChart, {
                propertiesChartData: _ctx.getPropertiesChart,
                location: _ctx.getLocation,
                scenario: _ctx.getScenario,
                matchingColors: _ctx.getMatchingColors,
                model: _ctx.getModel,
                onLocationPropertyChanged: _ctx.fetchPropertiesChartData
              }, null, 8, ["propertiesChartData", "location", "scenario", "matchingColors", "model", "onLocationPropertyChanged"])
            ]),
            _: 1
          }, 8, ["show"]),
          _createVNode(_component_v_container, {
            class: "fill-height d-print-none pa-0",
            fluid: "",
            style: {"width":"100%","position":"absolute","margin-left":"0","margin-right":"0","max-width":"unset"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_Mapbox, {
                  ref: "map",
                  poisInRangeFieldState: _ctx.getPoisInRangeFieldState,
                  areas: _ctx.getAreas,
                  poisInRange: _ctx.getPoisInRange,
                  satelliteView: _ctx.getSatelliteView,
                  showLocationOutput: _ctx.getShowLocationOutput,
                  onStartBusy: _ctx.setStartBusy,
                  leftPadding: _ctx.$refs?.leftDrawer?.offsetWidth,
                  rightPadding: _ctx.$refs?.rightDrawer?.offsetWidth,
                  onEndBusy: _ctx.setEndBusy,
                  onStartInProgress: _ctx.setStartInProgress,
                  onEndInProgress: _ctx.setEndInProgress,
                  onLegendChanged: _ctx.legendChanged,
                  onOutputLegendChanged: _ctx.outputLegendChanged,
                  onAreaLegendChanged: _ctx.areaLegendChanged,
                  onRasterLegendChanged: _ctx.rasterLegendChanged,
                  scenarioLocationsVisible: _ctx.getScenarioLocationsVisible,
                  mapState: _ctx.getMapState,
                  onMapStateChanged: _ctx.mapStateChanged,
                  area: _ctx.getArea,
                  mapTypeControl: true,
                  onMapBoundsChanged: _ctx.setMapBounds,
                  pois: _ctx.getPois,
                  heatMapPoints: _ctx.getHeatMapPoints,
                  searchResults: _ctx.getSearchResults,
                  mapFlyTo: _ctx.getMapFlyTo,
                  filter: _ctx.getFilterLocations,
                  filterLocations: _ctx.getFilterLocationIds,
                  streetViewControl: true,
                  onDeselect: _cache[8] || (_cache[8] = ($event: any) => {_ctx.setLocation(null);}),
                  onRightClick: _ctx.rightClick,
                  onLocationLeftClick: _ctx.leftClickLocation,
                  onSearchResultLeftClick: _ctx.leftClickSearchResult,
                  onScenarioLocationLeftClick: _ctx.leftClickScenarioLocation,
                  onLocationRightClick: _ctx.rightClickLocation,
                  locationCatchmentArea: _ctx.getLocationCatchmentArea,
                  catchmentArea: _ctx.getCatchmentArea,
                  locations: _ctx.locations,
                  scenarioLocations: _ctx.scenarioLocations,
                  locationIsoLines: _ctx.getLocationIsoLines,
                  isoLineSet: _ctx.getIsoLineSet,
                  isoLineMinutes: _ctx.getIsoLineMinutes,
                  model: _ctx.getModel,
                  location: _ctx.getLocation,
                  onlinePois: _ctx.getOnlinePois,
                  areaSetVisible: _ctx.getAreaSetVisible,
                  scenario: _ctx.getScenario,
                  onTooltipShow: _ctx.tooltipShow,
                  animate: true,
                  showFooterMenu: true,
                  legendData: _ctx.legendData,
                  outputLegendData: _ctx.outputLegendData,
                  areaLegendData: _ctx.areaLegendData,
                  rasterLegendData: _ctx.rasterLegendData
                }, null, 8, ["poisInRangeFieldState", "areas", "poisInRange", "satelliteView", "showLocationOutput", "onStartBusy", "leftPadding", "rightPadding", "onEndBusy", "onStartInProgress", "onEndInProgress", "onLegendChanged", "onOutputLegendChanged", "onAreaLegendChanged", "onRasterLegendChanged", "scenarioLocationsVisible", "mapState", "onMapStateChanged", "area", "onMapBoundsChanged", "pois", "heatMapPoints", "searchResults", "mapFlyTo", "filter", "filterLocations", "onRightClick", "onLocationLeftClick", "onSearchResultLeftClick", "onScenarioLocationLeftClick", "onLocationRightClick", "locationCatchmentArea", "catchmentArea", "locations", "scenarioLocations", "locationIsoLines", "isoLineSet", "isoLineMinutes", "model", "location", "onlinePois", "areaSetVisible", "scenario", "onTooltipShow", "legendData", "outputLegendData", "areaLegendData", "rasterLegendData"])
              ]),
              _renderSlot(_ctx.$slots, "fill")
            ]),
            _: 3
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_FloatingMenu, {
                onShowMatchingLocationsOutputChart: _cache[9] || (_cache[9] = ($event: any) => (_ctx.matchingLocationsOutputChartVisible = true)),
                onShowMatchingLocationsRadarChart: _cache[10] || (_cache[10] = ($event: any) => {_ctx.showMatchingScores();}),
                onShowDriversChart: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showDriversChart())),
                onShowPropertiesChart: _cache[12] || (_cache[12] = ($event: any) => {_ctx.propertiesChartVisible = true; _ctx.showPropertiesChart();}),
                onShowLocationReport: _cache[13] || (_cache[13] = ($event: any) => {_ctx.showLocationReport();}),
                onShowScenarioReport: _cache[14] || (_cache[14] = ($event: any) => {_ctx.fetchScenarioDifferences();  _ctx.scenarioReportVisible = false; _ctx.scenarioReportVisible = true;}),
                onShowLocationScores: _cache[15] || (_cache[15] = ($event: any) => {_ctx.showLocationScores();}),
                onShowAreaScores: _cache[16] || (_cache[16] = ($event: any) => {_ctx.areaScoresVisible = false; _ctx.areaScoresVisible = true}),
                onExportMap: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$refs?.map?.exportToPng()))
              })
            ])
          ]),
          (_ctx.getNotificationText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  size: "small",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setNotificationText(null))),
                  style: {"float":"right"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { color: "white" }, {
                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getNotificationText), 1)
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.model)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "tbdc-drawer d-print-none",
                    style: _normalizeStyle({ 'width': _ctx.leftDrawer.width + 'px' }),
                    ref: "leftDrawer"
                  }, [
                    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "tbdc-drawerborder" }, null, -1)),
                    (_ctx.location)
                      ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
                          default: _withCtx(() => [
                            _createElementVNode("h2", null, _toDisplayString(_ctx.$tc("message.locationsType" + _ctx.getModel.locationsType + "Name")), 1),
                            (_ctx.location)
                              ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_ctx.location.name), 1))
                              : _createCommentVNode("", true),
                            (_ctx.location.changeType != 2)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (!_ctx.getLocation)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t("message.drawerEmptyText")), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.getLocationPhoto != null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                        _createElementVNode("a", {
                                          href: _ctx.getLocationPhoto.googleMapsUrl,
                                          target: "_blank"
                                        }, [
                                          _createVNode(_component_v_img, {
                                            src: _ctx.getLocationPhoto.url,
                                            class: "mb-2",
                                            "max-height": "300",
                                            "max-width": "100%",
                                            style: {"border-radius":"5px","object-fit":"contain"}
                                          }, null, 8, ["src"])
                                        ], 8, _hoisted_11)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.getLocation && _ctx.getLocation.visibility == 0)
                                    ? (_openBlock(), _createBlock(_component_LocationInformation, {
                                        key: 2,
                                        model: _ctx.getModel,
                                        subModel: _ctx.getSubModel,
                                        location: _ctx.location,
                                        locationProperties: _ctx.getLocationProperties,
                                        locationPropertiesOld: _ctx.getLocationPropertiesOld,
                                        propertyIcons: _ctx.propertyIcons
                                      }, null, 8, ["model", "subModel", "location", "locationProperties", "locationPropertiesOld", "propertyIcons"]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 4))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, _ctx.location]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              (_ctx.model)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "tbdc-drawer tbdc-drawerright d-print-none",
                    style: _normalizeStyle({ 'width': _ctx.rightDrawer.width + 'px' }),
                    ref: "rightDrawer"
                  }, [
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "tbdc-drawerborder" }, null, -1)),
                    ((_ctx.getLocation && _ctx.getLocation.visibility == 0) || _ctx.getArea)
                      ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
                          default: _withCtx(() => [
                            (_ctx.location)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("h2", null, [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.calculationModelOutput")) + " ", 1),
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      variant: "text",
                                      onClick: _ctx.deselectLocation
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                            _createTextVNode("mdi-close", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  (_ctx.getLocation)
                                    ? (_openBlock(), _createElementBlock("h3", _hoisted_14, _toDisplayString(_ctx.getLocation.name), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.getLocation == null)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.$t("message.drawerEmptyText")), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        (_ctx.getScenario.status == 9)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                              _createVNode(_component_ModelOutput, {
                                                model: _ctx.getModel,
                                                subModel: _ctx.getSubModel,
                                                locationProperties: _ctx.getLocationProperties,
                                                location: _ctx.getLocation,
                                                propertyIcons: _ctx.propertyIcons
                                              }, null, 8, ["model", "subModel", "locationProperties", "location", "propertyIcons"]),
                                              (_ctx.getModel.hasNormalizedScoresFunctions)
                                                ? (_openBlock(), _createBlock(_component_MatchingLocations, {
                                                    key: 0,
                                                    matchingLocations: _ctx.getMatchingLocations,
                                                    location: _ctx.getLocation,
                                                    onLocationIdChanged: _ctx.setLocationByIdWithFocus
                                                  }, null, 8, ["matchingLocations", "location", "onLocationIdChanged"]))
                                                : _createCommentVNode("", true),
                                              _createVNode(_component_CatchmentAreaInformation, {
                                                model: _ctx.getModel,
                                                locationProperties: _ctx.getLocationProperties,
                                                location: _ctx.getLocation,
                                                locationCatchmentArea: _ctx.getLocationCatchmentArea,
                                                catchmentArea: _ctx.getCatchmentArea,
                                                onAreaSelected: _cache[19] || (_cache[19] = ($event: any) => {if (_ctx.getModel.catchmentAreaMode == 0) _ctx.fetchAreaWithLocations({ areaCode: $event, areaSetId: _ctx.getCatchmentArea.areaSetId } ); else _ctx.fetchArea({ areaCode: $event, areaSetId: _ctx.getCatchmentArea.areaSetId });})
                                              }, null, 8, ["model", "locationProperties", "location", "locationCatchmentArea", "catchmentArea"])
                                            ]))
                                          : (_ctx.getScenario.status > 0)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t("message.drawerCalculating")), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                                _createTextVNode(_toDisplayString(_ctx.$t("message.drawerNotCalculated")) + " ", 1),
                                                (_ctx.getModel && _ctx.getModel.roles.includes('Calculator'))
                                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                                      key: 0,
                                                      onClick: _cache[20] || (_cache[20] = ($event: any) => {_ctx.calculateScenario(_ctx.getScenario);}),
                                                      variant: "text",
                                                      color: "primary",
                                                      style: {"display":"block","position":"absolute","left":"50%","top":"50%","transform":"translate(-50%)"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t("message.calculateScenario")), 1)
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]))
                                      ]))
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.getArea && _ctx.getArea.areaCode != '')
                              ? (_openBlock(), _createBlock(_component_AreaInformation, {
                                  key: 1,
                                  model: _ctx.getModel,
                                  area: _ctx.getArea,
                                  onLocationChanged: _ctx.setLocation,
                                  scenario: _ctx.scenario,
                                  onAreaCleared: _ctx.clearArea
                                }, {
                                  actions: _withCtx(() => [
                                    _createVNode(_component_v_btn, {
                                      icon: "",
                                      variant: "text",
                                      onClick: _ctx.clearArea
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                            _createTextVNode("mdi-close", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["onClick"])
                                  ]),
                                  _: 1
                                }, 8, ["model", "area", "onLocationChanged", "scenario", "onAreaCleared"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 4))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, _ctx.location || (_ctx.getArea && _ctx.getArea.areaCode != '')]
          ]),
          _createVNode(_component_CopyChanges, {
            model: _ctx.getModel,
            scenarios: _ctx.getScenarios,
            scenario: _ctx.getScenarioMerging,
            onSave: _ctx.saveMergingScenarioLocal
          }, null, 8, ["model", "scenarios", "scenario", "onSave"]),
          _createVNode(_component_CloneScenario, {
            scenario: _ctx.getScenarioCloning,
            onSave: _ctx.saveCloningScenarioLocal
          }, null, 8, ["scenario", "onSave"]),
          _createVNode(_component_BulkUploadLocationsDialog, {
            model: _ctx.getModel,
            scenario: _ctx.getScenario,
            scenarios: _ctx.getScenarios,
            bulkUploadLocations: _ctx.getBulkUploadLocations,
            onSave: _ctx.saveBulkUploadLocationsLocal,
            onCancel: _ctx.cancelBulkUploadLocations
          }, null, 8, ["model", "scenario", "scenarios", "bulkUploadLocations", "onSave", "onCancel"]),
          _createVNode(_component_ExportAreasDialog, {
            model: _ctx.getModel,
            exportAreasDialog: _ctx.getExportAreasDialog,
            onSave: _ctx.saveExportAreasLocal,
            onCancel: _ctx.cancelExportAreas
          }, null, 8, ["model", "exportAreasDialog", "onSave", "onCancel"]),
          _createVNode(_component_EditScenario, {
            model: _ctx.getModel,
            scenarios: _ctx.getScenarios,
            scenario: _ctx.getScenarioEditing,
            originalScenario: _ctx.getScenario,
            isScoreModel: _ctx.getSubModel != null ? _ctx.getSubModel.functionCount > 0 : false,
            onSave: _ctx.saveScenarioEditing
          }, null, 8, ["model", "scenarios", "scenario", "originalScenario", "isScoreModel", "onSave"]),
          _createVNode(_component_EditScenarioName, {
            scenario: _ctx.getScenarioNameEditing,
            onSave: _ctx.saveScenarioEditing
          }, null, 8, ["scenario", "onSave"]),
          _createVNode(_component_EditLocation, {
            model: _ctx.getModel,
            scenario: _ctx.getScenario,
            location: _ctx.getLocationEditing,
            onSave: _ctx.saveLocationEditing,
            onChanged: _ctx.editLocationChanged
          }, null, 8, ["model", "scenario", "location", "onSave", "onChanged"]),
          _createVNode(_component_CloseLocation, {
            model: _ctx.getModel,
            scenario: _ctx.getScenario,
            location: _ctx.getLocationClosing,
            onSave: _ctx.saveLocationClosing
          }, null, 8, ["model", "scenario", "location", "onSave"]),
          _createVNode(_component_EditModelParameters, {
            model: _ctx.getModel,
            modelParameters: _ctx.getModelParameters,
            onSave: _ctx.saveModelParameters
          }, null, 8, ["model", "modelParameters", "onSave"]),
          _createVNode(_component_EditDrivers, {
            model: _ctx.getModel,
            driverFilters: _ctx.getDrivers,
            onSave: _ctx.saveDrivers
          }, null, 8, ["model", "driverFilters", "onSave"]),
          _createVNode(_component_EditNormalizedScoresFunctions, {
            model: _ctx.getModel,
            normalizedScoresFunctions: _ctx.getNormalizedScoresFunctions,
            onSave: _ctx.saveNormalizedScoresFunctions
          }, null, 8, ["model", "normalizedScoresFunctions", "onSave"]),
          _createVNode(_component_ScenarioProcessingLog, {
            model: _ctx.getModel,
            user: _ctx.getUser,
            scenarioProcessingLog: _ctx.getScenarioProcessingLog,
            scenario: _ctx.getScenario
          }, null, 8, ["model", "user", "scenarioProcessingLog", "scenario"]),
          _createVNode(_component_NCalcTester, { showNCalc: _ctx.getNCalcTester }, null, 8, ["showNCalc"]),
          _createVNode(_component_WhoHasAccess, {
            model: _ctx.getModel,
            modelAccess: _ctx.getModelAccess
          }, null, 8, ["model", "modelAccess"]),
          (_ctx.tooltipShowArguments && (_ctx.tooltipShowArguments.title || _ctx.tooltipShowArguments.titleHtml))
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "pa-2 tbdc-tooltip",
                style: _normalizeStyle({'z-index': '10','background-color': 'white',position: 'absolute',top:_ctx.tooltipShowArguments.y + 5 + 'px',left:_ctx.tooltipShowArguments.x + 5 +'px'})
              }, [
                (_ctx.tooltipShowArguments.titleHtml)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      innerHTML: _ctx.tooltipShowArguments.titleHtml
                    }, null, 8, _hoisted_20))
                  : _createCommentVNode("", true),
                (_ctx.tooltipShowArguments.title)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_21, _toDisplayString(_ctx.tooltipShowArguments.title), 1))
                  : _createCommentVNode("", true)
              ], 4))
            : _createCommentVNode("", true),
          (_ctx.locationContextMenuArguments && _ctx.locationContextMenuArguments.location && _ctx.locationContextMenuArguments.location.visibility == 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "pa-4 tbdc-tooltip",
                oncontextmenu: "return false;",
                style: _normalizeStyle({'z-index': '10','background-color': 'white',position: 'absolute',top:_ctx.locationContextMenuArguments.y - 5 + 'px',left:_ctx.locationContextMenuArguments.x - 5 +'px'}),
                onMouseleave: _cache[27] || (_cache[27] = ($event: any) => {_ctx.mapContextMenuArguments = null; _ctx.locationContextMenuArguments = null})
              }, [
                _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.locationContextMenuArguments.location.name), 1),
                _createVNode(_component_v_list, {
                  density: "compact",
                  class: "pa-0",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      ((_ctx.locationContextMenuArguments.location.changeType == 0 || _ctx.locationContextMenuArguments.location.changeType == 1 || _ctx.locationContextMenuArguments.location.changeType == 3) && _ctx.getModel && _ctx.getModel.roles.includes('Editor'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 0,
                            style: {"padding":"0"},
                            disabled: _ctx.getReadOnly,
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.editLocation(_ctx.locationContextMenuArguments.location)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                      _createTextVNode("mdi-pencil-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.edit")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.locationContextMenuArguments.location.changeType == 0 && _ctx.getModel && _ctx.getModel.roles.includes('Editor'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            style: {"padding":"0"},
                            disabled: _ctx.getReadOnly,
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.closeLocation(_ctx.locationContextMenuArguments.location)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                      _createTextVNode("mdi-close-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.close")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.locationContextMenuArguments.location.changeType == 1 && _ctx.getModel && _ctx.getModel.roles.includes('Editor'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 2,
                            style: {"padding":"0"},
                            disabled: _ctx.getScenario.parentScenarioId == null || _ctx.getReadOnly,
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.confirmRemoveLocation(_ctx.locationContextMenuArguments.location)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                      _createTextVNode("mdi-delete-outline", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.delete")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.locationContextMenuArguments.location.changeType == 2 && _ctx.getModel && _ctx.getModel.roles.includes('Editor'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 3,
                            style: {"padding":"0"},
                            disabled: _ctx.getScenario.parentScenarioId == null || _ctx.getReadOnly,
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.undoCloseLocation(_ctx.locationContextMenuArguments.location)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                                      _createTextVNode("mdi-undo-variant", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.undoClose")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.locationContextMenuArguments.location.changeType == 3 && _ctx.getModel && _ctx.getModel.roles.includes('Editor'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 4,
                            style: {"padding":"0"},
                            disabled: _ctx.getScenario.parentScenarioId == null || _ctx.getReadOnly,
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.confirmUndoEditLocation(_ctx.locationContextMenuArguments.location)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                      _createTextVNode("mdi-undo-variant", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.undoEdit")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_list_item, {
                        style: {"padding":"0"},
                        onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.navigateTo('https://www.google.com/maps?q=' + _ctx.locationContextMenuArguments.location.latitude + ',' + _ctx.locationContextMenuArguments.location.longitude)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                                  _createTextVNode("mdi-map-marker", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("message.googleMaps")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ], 36))
            : _createCommentVNode("", true),
          (_ctx.mapContextMenuArguments)
            ? (_openBlock(), _createElementBlock("div", {
                key: 5,
                class: "pa-4 tbdc-tooltip",
                oncontextmenu: "return false;",
                style: _normalizeStyle({'z-index': '10','background-color': 'white',position: 'absolute',top:_ctx.mapContextMenuArguments.y - 5 + 'px',left:_ctx.mapContextMenuArguments.x - 5 +'px'}),
                onMouseleave: _cache[31] || (_cache[31] = ($event: any) => {_ctx.mapContextMenuArguments = null; _ctx.locationContextMenuArguments = null})
              }, [
                _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.mapContextMenuArguments.name || _ctx.formatCoordinates(_ctx.mapContextMenuArguments.latitude,_ctx.mapContextMenuArguments.longitude)), 1),
                _createVNode(_component_v_list, {
                  density: "compact",
                  class: "pa-0",
                  color: "primary"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (_ctx.getModel && _ctx.getModel.roles.includes('Editor'))
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 0,
                            style: {"padding":"0"},
                            disabled: _ctx.getReadOnly,
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.editNewLocationWithDefaultCheck({ createScenarioParentId: _ctx.getScenario.parentScenarioId, parentScenarioId: _ctx.getScenario.parentScenarioId, scenarioId: _ctx.getScenario.id , name: '', locationGroup: null, locationCluster: null, latitude: _ctx.mapContextMenuArguments.latitude, longitude: _ctx.mapContextMenuArguments.longitude })))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                                      _createTextVNode("mdi-plus", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.locationsType" + _ctx.model.locationsType + "New")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_list_item, {
                        style: {"padding":"0"},
                        onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.navigateTo('https://www.google.com/maps?q=' + _ctx.mapContextMenuArguments.latitude + ',' + _ctx.mapContextMenuArguments.longitude)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_action, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                  _createTextVNode("mdi-map-marker", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("message.googleMaps")), 1)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      (_ctx.getModel.catchmentAreaMode == 0)
                        ? (_openBlock(), _createBlock(_component_v_list_item, {
                            key: 1,
                            style: {"padding":"0"},
                            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.fetchAreaWithLocations({ arguments: _ctx.mapContextMenuArguments, areaSetId: _ctx.getModel.areaSets[0].id })))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                      _createTextVNode("mdi-land-fields", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.areaInformationCatchmentArea")), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleAreaSets, (areaSet) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: 'as2' + areaSet.id
                        }, [
                          (_openBlock(), _createBlock(_component_v_list_item, {
                            style: {"padding":"0"},
                            key: areaSet.id,
                            onClick: ($event: any) => (_ctx.fetchArea( { arguments: _ctx.mapContextMenuArguments , areaSetId: areaSet.id }))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_action, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                      _createTextVNode("mdi-land-fields", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", null, [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t("message.areaInformation")) + " (" + _toDisplayString(areaSet.title) + ")", 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ], 36))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }))
    : _createCommentVNode("", true)
}